const config = {
    region: "europe-west3"
};

export {config};
